import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { VehicleColorTypeEnum } from '../enums/vehicle-color-type.enum';

/**
 * Vehicle color record DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleColorRecordDto extends BaseDto {
	name!: string;
	notes?: string;
	type!: VehicleColorTypeEnum;
	externalReference?: string;
}
